import { get, isNil, keys, map } from 'lodash'

const getFilterOptions = (
  options,
  labelPath,
  valuePath,
  disablePath = 'disabled',
) =>
  map(keys(options), key => ({
    label: !isNil(labelPath)
      ? get(options, `${key}.${labelPath}`)
      : options[key],
    value: !isNil(valuePath) ? get(options, `${key}.${valuePath}`) : key,
    disabled: get(options, `${key}.${disablePath}`),
  }))

export default getFilterOptions
